var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "content-wrappper" },
      [
        _c("div", { staticClass: "row mr-0 ml-0" }, [
          _c("div", { staticClass: "col-xs-12 col-sm-12 p-15" }, [
            _vm.enableAddRole
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-offset-5 col-md-offset-4 col-sm-offset-3 col-xs-offset-0 sx-align-right",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-white-button margin",
                        attrs: { type: "button" },
                        on: { click: _vm.marketPlaceServices },
                      },
                      [
                        _c("img", {
                          staticClass: "tracker-images",
                          attrs: {
                            src: "/static/images/icons/marketplace_service_icon.svg",
                            alt: "marketplace-icon",
                          },
                        }),
                        _c("span", { staticClass: "text-color-blue" }, [
                          _vm._v("Master Services"),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-white-button margin",
                        attrs: { type: "button" },
                        on: { click: _vm.addRoleTemplate },
                      },
                      [
                        _c("img", {
                          staticClass: "tracker-images",
                          attrs: {
                            src: "/static/images/icons/profile_icon.svg",
                            alt: "profile-icon",
                          },
                        }),
                        _c("span", { staticClass: "text-color-blue" }, [
                          _vm._v("Import Role Template"),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-green-button margin",
                        attrs: { type: "button" },
                        on: { click: _vm.addRole },
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus" }),
                        _vm._v(" Add Role"),
                      ]
                    ),
                  ]
                )
              : _c("div", { staticClass: "col-sm-offset-9 col-xs-offset-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.addRoleTemplate },
                    },
                    [
                      _c("img", {
                        staticClass: "tracker-images",
                        attrs: {
                          src: "/static/images/icons/profile_icon.svg",
                          alt: "profile-icon",
                        },
                      }),
                      _c("span", { staticClass: "text-color-blue" }, [
                        _vm._v("Import Role Template"),
                      ]),
                    ]
                  ),
                ]),
          ]),
        ]),
        _c("RBACGrid", { on: { uploadType: _vm.uploadType } }),
        _c("rbac-add-role-modal", {
          attrs: { type: _vm.type, header: _vm.header, roleInfo: _vm.roleData },
          on: { uploadJsonModal: _vm.rbacUploadJSONPopup },
        }),
        _c("rbac-upload-json-modal", {
          attrs: {
            type: _vm.type,
            selectedRoleIdToUpload: _vm.selectedRoleIdToUpload,
          },
          on: { openAddRolePopup: _vm.addRolePopup },
        }),
        _c("rbac-mrkt-place-services-modal"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }